module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Dunkirk_.be39f6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Dunkirk_.jpg
// module id = ftl6
// module chunks = 0